"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postRegTextContent = exports.generatePostRegText = void 0;
const preregistration_1 = require("./preregistration");
const generatePostRegText = (config) => {
    const matchingContent = exports.postRegTextContent.find(({ checkInVote, voteType, postRegistration, sweepstakes }) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return checkInVote === ((_b = (_a = config.fields) === null || _a === void 0 ? void 0 : _a.checkInVote) === null || _b === void 0 ? void 0 : _b.content) &&
            (voteType || "") === ((_d = (_c = config.fields) === null || _c === void 0 ? void 0 : _c.voteType) === null || _d === void 0 ? void 0 : _d.content) &&
            postRegistration === ((_f = (_e = config.fields) === null || _e === void 0 ? void 0 : _e.postRegistration) === null || _f === void 0 ? void 0 : _f.content) &&
            sweepstakes === ((_h = (_g = config.fields) === null || _g === void 0 ? void 0 : _g.sweepstakes) === null || _h === void 0 ? void 0 : _h.content);
    });
    const update = (v) => {
        var _a, _b, _c;
        return (0, preregistration_1.updateStringVars)(v, [
            { key: "artist", value: config.artistName || "" },
            {
                key: "title",
                value: ((_c = (_b = (_a = config.fields) === null || _a === void 0 ? void 0 : _a.postRegistrationAlbum) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.name) || "",
            },
        ]);
    };
    const updatedContent = {
        headline: update((matchingContent === null || matchingContent === void 0 ? void 0 : matchingContent.headline) || ""),
        body: update((matchingContent === null || matchingContent === void 0 ? void 0 : matchingContent.body) || ""),
        ctalabel: update((matchingContent === null || matchingContent === void 0 ? void 0 : matchingContent.ctalabel) || ""),
        cta: update((matchingContent === null || matchingContent === void 0 ? void 0 : matchingContent.cta) || ""),
    };
    return updatedContent;
};
exports.generatePostRegText = generatePostRegText;
exports.postRegTextContent = [
    {
        checkInVote: "checkin",
        sweepstakes: true,
        postRegistration: "promo",
        headline: "Thanks for checking in!",
        body: "Please take a minute to save {title} on your favorite streaming service.",
        ctalabel: "Save",
        cta: "social",
    },
    {
        checkInVote: "checkin",
        sweepstakes: false,
        postRegistration: "promo",
        headline: "Thanks for checking in!",
        body: "Please take a minute to save {title} on your favorite streaming service.",
        ctalabel: "Save",
        cta: "social",
    },
    {
        checkInVote: "vote",
        voteType: "song",
        sweepstakes: true,
        postRegistration: "promo",
        headline: "Thanks for your vote!",
        body: "Please take a minute to save {title} on your favorite streaming service.",
        ctalabel: "Save",
        cta: "social",
    },
    {
        checkInVote: "vote",
        voteType: "song",
        sweepstakes: false,
        postRegistration: "promo",
        headline: "Thanks for your vote!",
        body: "Please take a minute to save {title} on your favorite streaming service.",
        ctalabel: "Save",
        cta: "social",
    },
    {
        checkInVote: "vote",
        voteType: "vote",
        sweepstakes: true,
        postRegistration: "promo",
        headline: "Thanks for taking part in the show!",
        body: "Please take a minute to save {title} on your favorite streaming service.",
        ctalabel: "Save",
        cta: "social",
    },
    {
        checkInVote: "vote",
        voteType: "vote",
        sweepstakes: false,
        postRegistration: "promo",
        headline: "Thanks for taking part in the show!",
        body: "Please take a minute to save {title} on your favorite streaming service.",
        ctalabel: "Save",
        cta: "social",
    },
    {
        checkInVote: "checkin",
        sweepstakes: true,
        postRegistration: "link",
        headline: "Thanks for checking in!",
        body: "Hey check out this link",
        ctalabel: "Click Here",
        cta: "https://",
    },
    {
        checkInVote: "checkin",
        sweepstakes: false,
        postRegistration: "link",
        headline: "Thanks for checking in!",
        body: "Hey check out this link",
        ctalabel: "Click Here",
        cta: "https://",
    },
    {
        checkInVote: "vote",
        voteType: "song",
        sweepstakes: true,
        postRegistration: "link",
        headline: "Thanks for your vote!",
        body: "Hey check out this link",
        ctalabel: "Click Here",
        cta: "https://",
    },
    {
        checkInVote: "vote",
        voteType: "song",
        sweepstakes: false,
        postRegistration: "link",
        headline: "Thanks for your vote!",
        body: "Hey check out this link",
        ctalabel: "Click Here",
        cta: "https://",
    },
    {
        checkInVote: "vote",
        voteType: "vote",
        sweepstakes: true,
        postRegistration: "link",
        headline: "Thanks for taking part in the show!",
        body: "Hey check out this link",
        ctalabel: "Click Here",
        cta: "https://",
    },
    {
        checkInVote: "vote",
        voteType: "vote",
        sweepstakes: false,
        postRegistration: "link",
        headline: "Thanks for taking part in the show!",
        body: "Hey check out this link",
        ctalabel: "Click Here",
        cta: "https://",
    },
    {
        checkInVote: "checkin",
        sweepstakes: true,
        postRegistration: "thank",
        headline: "Thanks for checking in!",
        body: "You're now entered to win and will be the first to hear about {artist} news!",
    },
    {
        checkInVote: "checkin",
        sweepstakes: false,
        postRegistration: "thank",
        headline: "Thanks for checking in!",
        body: "You will now be the first to hear about {artist} news!",
    },
    {
        checkInVote: "vote",
        voteType: "song",
        sweepstakes: true,
        postRegistration: "thank",
        headline: "Thanks for your vote!",
        body: "The winning song will be announced later in the show!",
    },
    {
        checkInVote: "vote",
        voteType: "song",
        sweepstakes: false,
        postRegistration: "thank",
        headline: "Thanks for your vote!",
        body: "The winning song will be announced later in the show!",
    },
    {
        checkInVote: "vote",
        voteType: "vote",
        sweepstakes: true,
        postRegistration: "thank",
        headline: "Thanks for taking part in the show!",
        body: "You're now entered to win!",
    },
    {
        checkInVote: "vote",
        voteType: "vote",
        sweepstakes: false,
        postRegistration: "thank",
        headline: "Thanks for taking part in the show!",
        body: "Your participation is appreciated!",
    },
];
//# sourceMappingURL=postregistration.js.map